import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class SettingsResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("SettingsResourcesPackage");
    }
    public get assets_settings_button_yellow_png(): Texture {
        return this.resource<Texture>("assets/settings/button_yellow.png");
    }
    public get assets_settings_czech_png(): Texture {
        return this.resource<Texture>("assets/settings/czech.png");
    }
    public get assets_settings_english_png(): Texture {
        return this.resource<Texture>("assets/settings/english.png");
    }
    public get assets_settings_france_png(): Texture {
        return this.resource<Texture>("assets/settings/france.png");
    }
    public get assets_settings_germany_png(): Texture {
        return this.resource<Texture>("assets/settings/germany.png");
    }
    public get assets_settings_italy_png(): Texture {
        return this.resource<Texture>("assets/settings/italy.png");
    }
    public get assets_settings_japan_png(): Texture {
        return this.resource<Texture>("assets/settings/japan.png");
    }
    public get assets_settings_polish_png(): Texture {
        return this.resource<Texture>("assets/settings/polish.png");
    }
    public get assets_settings_russia_png(): Texture {
        return this.resource<Texture>("assets/settings/russia.png");
    }
    public get assets_settings_shine_png(): Texture {
        return this.resource<Texture>("assets/settings/shine.png");
    }
    public get assets_settings_spain_png(): Texture {
        return this.resource<Texture>("assets/settings/spain.png");
    }
    public get assets_settings_toggle_off_png(): Texture {
        return this.resource<Texture>("assets/settings/toggle_off.png");
    }
    public get assets_settings_toggle_on_png(): Texture {
        return this.resource<Texture>("assets/settings/toggle_on.png");
    }
}

